import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromDeviceMgtList from './reducers/device-mgt-list.reducer';
import { DeviceMgtListEffects } from './effects/device-mgt-list.effects';
import * as fromDeviceMgtListFilter from './reducers/device-mgt-list-filter.reducer';
import * as fromDeviceSettingList from './reducers/device-setting-list.reducer';
import * as fromDeviceDetail from './reducers/device-detail.reducer';
import { DeviceDetailEffects } from './effects/device-detail.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ DeviceMgtListEffects, DeviceDetailEffects]),
    StoreModule.forFeature('deviceMgtList', fromDeviceMgtList.reducer),
    StoreModule.forFeature('deviceMgtListFilter', fromDeviceMgtListFilter.reducer),
    StoreModule.forFeature('deviceSettingList', fromDeviceSettingList.reducer),
    StoreModule.forFeature('deviceDetail', fromDeviceDetail.reducer),
  ]
})
export class DeviceMgtModule { }
